export const PAGE_SIZE = 10;

export enum ProjectTypeAccessorKey {
  name = 'name',
  area = 'area',
  monetaryRisk = 'monetaryRisk',
  natureRisk = 'natureRisk',
  resilience = 'resilience',
  type = 'type',
  labels = 'labels',
  carbonStorageAg = 'carbonStorageAg',
  carbonStorageAgTrend_1y = 'carbonStorageAgTrend_1y',
  carbonStorageBg = 'carbonStorageBg',
  carbonStorageBgTrend_1y = 'carbonStorageBgTrend_1y',
  waterHoldingCapacity = 'waterHoldingCapacity',
  waterHoldingCapacityTrend_1y = 'waterHoldingCapacityTrend_1y',
  canopyHeight = 'canopyHeight',
  canopyCover = 'canopyCover',
  biodiversityZone = 'biodiversityZone',
  biodiversityZoneTrend_1y = 'biodiversityZoneTrend_1y',
  eii = 'eii',
  habitatIntactness = 'habitatIntactness',
  habitatIntactnessTrend_5y = 'habitatIntactnessTrend_5y',
}
